import NavbarDashboard from "../components/navbarDashboard/NavbarDashboard";
import * as React from "react";
import Typography from "@mui/material/Typography";
import { Stack, Button, Dialog, DialogActions, DialogContent, DialogTitle, Alert } from "@mui/material";
import YearSelect from "../components/YearSelector/YearSelect";
import CardDashboard from "../components/CardDisplay/CardDashBoard";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";

const API_URL = process.env.REACT_APP_API_URL;

const AdminPageReport = () => {
  const currentMonth = new Date().getMonth() + 1;
  const quarters = {
    "JAN-FEB-MAR": "1",
    "APR-MAY-JUN": "2",
    "JUL-AUG-SEP": "3",
    "OCT-NOV-DEC": "4",
  };
  const quarter_dic = {
    1: [1, 2, 3],   // Q1
    2: [4, 5, 6],   // Q2
    3: [7, 8, 9],   // Q3
    4: [10, 11, 12] // Q4
  };
  const quarterList = ["JAN-FEB-MAR", "APR-MAY-JUN", "JUL-AUG-SEP", "OCT-NOV-DEC"];
  let quar = 0;
  for (const [key, months] of Object.entries(quarter_dic)) {
    if (months.includes(currentMonth)) {
      quar = parseInt(key, 10);
      break;
    }
  }

  const [reportData, setReportData] = React.useState({});
  const [year, setYear] = React.useState(new Date().getFullYear().toString());
  const [openPopup, setOpenPopup] = React.useState(false);
  const [selectedDate, setSelectedDate] = React.useState(dayjs());
  const [selectedQuarter, setSelectedQuarter] = React.useState("");
  const [fetchErrors, setFetchErrors] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    console.log("Quarter", quar);
  }, []);

  const updateYear = (value) => {
    setYear(value);
    setFetchErrors([]);
  };

  const fetchWithRetry = async (url, options, retries = 2) => {
    for (let i = 0; i < retries; i++) {
      try {
        const response = await fetch(url, options);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return await response.json();
      } catch (error) {
        if (i === retries - 1) throw error;
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    }
  };

  React.useEffect(() => {
    const jwt = localStorage.getItem("jwt");
    if (!jwt) {
      setFetchErrors(["No JWT token found. Please log in again."]);
      return;
    }

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    };

    setIsLoading(true);
    Promise.all(
      quarterList.map((quarter) =>
        fetchWithRetry(`${API_URL}/api/admin/report/${year}/${quarter}`, requestOptions)
          .then((data) => ({ quarter, data }))
          .catch((error) => {
            console.error(`Error fetching ${quarter}:`, error.message);
            setFetchErrors((prev) => [...prev, `Failed to fetch ${quarter}: ${error.message}`]);
            return { quarter, data: null };
          })
      )
    )
      .then((results) => {
        const dataByQuarter = results.reduce((acc, { quarter, data }) => {
          if (data) {
            acc[quarter] = data;
          }
          return acc;
        }, {});
        setReportData(dataByQuarter);
        console.log("Fetched data:", dataByQuarter);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Unexpected fetch error:", error);
        setFetchErrors((prev) => [...prev, "An unexpected error occurred while fetching data."]);
        setIsLoading(false);
      });
  }, [year]);

  const handleSave = () => {
    const jwt = localStorage.getItem("jwt");
    if (!jwt) {
      setFetchErrors(["No JWT token found. Please log in again."]);
      setOpenPopup(false);
      return;
    }

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
      body: JSON.stringify({ deadline: selectedDate.toISOString() }),
    };
    fetch(
      `${API_URL}/api/admin/report/extend/${year}/${selectedQuarter}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) throw new Error(`Failed to update deadline: ${response.statusText}`);
        return response.json();
      })
      .then((data) => {
        console.log("Deadline updated:", data);
        setOpenPopup(false);
        const requestOptionsGet = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
        };
        fetchWithRetry(`${API_URL}/api/admin/report/${year}/${selectedQuarter}`, requestOptionsGet)
          .then((data) => {
            setReportData((prev) => ({ ...prev, [selectedQuarter]: data }));
          })
          .catch((error) => {
            console.error(`Error refreshing data for ${selectedQuarter}:`, error);
            setFetchErrors((prev) => [...prev, `Error refreshing ${selectedQuarter}: ${error.message}`]);
          });
      })
      .catch((error) => {
        console.error("Error updating deadline:", error);
        setFetchErrors((prev) => [...prev, `Failed to update deadline for ${selectedQuarter}: ${error.message}`]);
      });
  };

  return (
    <div>
      <NavbarDashboard />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: "7%",
          marginBottom: "-11%",
          marginRight: "5%",
        }}
      >
        <YearSelect yearUpdate={updateYear} />
      </div>
      {fetchErrors.length > 0 && (
        <Stack sx={{ width: "100%", marginTop: "20px" }} spacing={2}>
          {fetchErrors.map((error, index) => (
            <Alert key={index} severity="error">
              {error}
            </Alert>
          ))}
        </Stack>
      )}
      {isLoading && (
        <Typography sx={{ textAlign: "center", marginTop: "20px", color: "#FFFFFF" }}>
          Loading...
        </Typography>
      )}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "100vh",
        }}
      >
        <div style={{ marginLeft: "15%" }}>
          <Typography
            variant="h4"
            component="div"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: "bold",
              color: "#FFFFFF",
            }}
          >
            QUARTER
          </Typography>
          <Typography
            variant="h3"
            component="div"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: "bold",
              color: "#79DCFF",
              textTransform: "lowercase",
              "&:first-letter": {
                textTransform: "capitalize",
              },
            }}
          >
            SELECTOR
          </Typography>
        </div>
        <div style={{ marginRight: "20%", marginTop: "4%" }}>
          <Stack spacing={3}>
            <Stack direction="row" spacing={2}>
              <CardDashboard
                currentYear={year}
                id={reportData["JAN-FEB-MAR"]?.[0]?.reports?.[0]?.id || null}
                index={1}
                stage={quar === 1 ? "New" : "Closed"}
                currentQuarter={"JAN-FEB-MAR"}
                isEdit={quar === 1}
                isDownload={true}
                isReport={quar === 1}
                deadline={reportData["JAN-FEB-MAR"]?.[0]?.deadline || null}
                onDateClick={() => {
                  setSelectedQuarter("JAN-FEB-MAR");
                  setOpenPopup(true);
                }}
              />
              <CardDashboard
                currentYear={year}
                id={reportData["APR-MAY-JUN"]?.[0]?.reports?.[0]?.id || null}
                index={2}
                stage={quar === 2 ? "New" : "Closed"}
                currentQuarter={"APR-MAY-JUN"}
                isEdit={quar === 2}
                isDownload={true}
                isReport={quar === 2}
                deadline={reportData["APR-MAY-JUN"]?.[0]?.deadline || null}
                onDateClick={() => {
                  setSelectedQuarter("APR-MAY-JUN");
                  setOpenPopup(true);
                }}
              />
            </Stack>
            <Stack direction="row" spacing={2}>
              <CardDashboard
                currentYear={year}
                id={reportData["JUL-AUG-SEP"]?.[0]?.reports?.[0]?.id || null}
                index={3}
                stage={quar === 3 ? "New" : "Closed"}
                currentQuarter={"JUL-AUG-SEP"}
                isEdit={quar === 3}
                isDownload={true}
                isReport={quar === 3}
                deadline={reportData["JUL-AUG-SEP"]?.[0]?.deadline || null}
                onDateClick={() => {
                  setSelectedQuarter("JUL-AUG-SEP");
                  setOpenPopup(true);
                }}
              />
              <CardDashboard
                currentYear={year}
                id={reportData["OCT-NOV-DEC"]?.[0]?.reports?.[0]?.id || null}
                index={4}
                stage={quar === 4 ? "New" : "Closed"}
                currentQuarter={"OCT-NOV-DEC"}
                isEdit={quar === 4}
                isDownload={true}
                isReport={quar === 4}
                deadline={reportData["OCT-NOV-DEC"]?.[0]?.deadline || null}
                onDateClick={() => {
                  setSelectedQuarter("OCT-NOV-DEC");
                  setOpenPopup(true);
                }}
              />
            </Stack>
          </Stack>
        </div>
      </div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Dialog open={openPopup} onClose={() => setOpenPopup(false)}>
          <DialogTitle>Set Deadline</DialogTitle>
          <DialogContent>
            <DateTimePicker
              label="Deadline Date & Time"
              value={selectedDate}
              onChange={(newValue) => setSelectedDate(newValue)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenPopup(false)}>Cancel</Button>
            <Button onClick={handleSave}>Save</Button>
          </DialogActions>
        </Dialog>
      </LocalizationProvider>
    </div>
  );
};

export default AdminPageReport;